<template>
  <div class="account-manage-users-list">
    <user-row
      v-for="user in users"
      :key="user.id"
      :user="user"
      :search-term="searchTerm"
      :is-current-user="user.id === userAccount.id"
      :current-user-is-admin="currentUserIsAdmin"
      :current-account-is-company="currentAccountIsCompany"
      @editUser="editUser(user)"
      @confirmUser="confirmUser(user)"
      @deactivateUser="deactivateUser(user)"
      @showAssignments="showAssignments(user)"
      @deleteUser="deleteUser(user)"
      @resendInvitation="resendInvitation(user)"
      @changeAccountType="changeAccountType(user)"
    />
  </div>
</template>

<script>
  import userRow from './UserRow.vue';
  export default {
    name: 'UsersList',
    components: {userRow},
    props: {
      users: {
        type: Array,
        required: true
      },
      searchTerm: {
        type: String,
        required: true
      },
      userAccount:{
        type: Object,
        required: true
      },
      currentUserIsAdmin: {
        type: Boolean,
        required: true
      },
      currentAccountIsCompany: {
        type: Boolean,
        required: true
      },
    },
    methods: {
      editUser(user) {
        this.$emit('editUser', user);
      },
      confirmUser(user) {
        this.$emit('confirmUser', user);
      },
      deactivateUser(user) {
        this.$emit('deactivateUser', user);
      },
      showAssignments(user) {
        this.$emit('showAssignments', user);
      },
      deleteUser(user){
        return this.$emit('deleteUser', user);
      },
      resendInvitation(user) {
        this.$emit('resendInvitation', user);
      },
      changeAccountType(user) {
        this.$emit('changeAccountType', user);
      }
    }
  }
</script>

<style lang="stylus">

</style>
